import flatten from 'lodash/flatten';
import max from 'lodash/max';
import min from 'lodash/min';
import moment from 'moment';

export const allowAgendaByAvailable = (date, { agendas, availables, unavailables }) =>
    (isInAgendas(date, agendas) || isInAvailable(date, availables)) && !isInUnavailables(date, unavailables)
;

export const getLimits = ({ agendas = [], availables = [] }) => {
    const minTime = agendas.length === 0 ? '00:00' : min(flatten(agendas.map(({ days_of_week }) => days_of_week.map(({ from_time }) => from_time))));
    const maxTime = agendas.length === 0 ? '23:59' :  max(flatten(agendas.map(({ days_of_week }) => days_of_week.map(({ to_time }) => to_time))));

    const minAvailable = availables.length === 0 ? '23:59' : min(flatten(availables.map(({ from_time }) => from_time)));
    const maxAvailable = availables.length === 0 ? '00:00' : max(flatten(availables.map(({ to_time }) => to_time)));

    const minimum = min([minTime ? minTime : '00:00', minAvailable ? minAvailable : '23:59']);
    const maximum = max([maxTime ? maxTime : '23:59', maxAvailable ? maxAvailable : '00:00']);

    return {
        max: moment(maximum, 'HH:mm').toDate(),
        min: moment(minimum, 'HH:mm').toDate()
    };
};

export const isAvailableDay = (date, agendas = [], availables = []) =>
    agendas.some(({ days_of_week, from_date, to_date }) =>
        date.isBetween(moment(from_date), moment(to_date), 'day', '[]')
        && days_of_week.some(({ day }) =>
            day === (!!date.day() ? date.day() : 7)
        ))
    || availables.some(({ from_date, to_date }) => {
        const fromDate = moment(from_date);
        const toDate = moment(to_date);
        return date.isBetween(fromDate, toDate, 'day', '[]');
    });

export const isInAgendas = (date, agendas = []) =>
    agendas.some(({ days_of_week, from_date, to_date }) =>
        date.isBetween(moment(from_date), moment(to_date), 'day', '[]')
        && days_of_week.some(({ day, from_time, to_time }) =>
            day === (!!date.day() ? date.day() : 7)
            && from_time <= date.format('HH:mm')
            && date.format('HH:mm') < to_time
        )
    );

export const isInAvailable = (date, availables = []) =>
    availables.some(({ from_date, from_time, to_date, to_time }) => {
        const fromDate = moment(from_date);
        const toDate = moment(to_date);
        const time = date.format('HH:mm');
        return date.isBetween(fromDate, toDate, 'day', '[]') && (time >= from_time && time < to_time);
    });

export const isInUnavailables = (date, unavailables = []) =>
    unavailables.some(({ all_day, from_date, from_time, to_date, to_time }) => {
        const fromDate = moment(from_date);
        const toDate = moment(to_date);
        const time = date.format('HH:mm');
        return date.isBetween(fromDate, toDate, 'day', '[]') && (!!all_day || (time >= from_time && time < to_time));
    });

export const isTurnOverlaping = (start, end, turns) =>
    !start || !end || turns.some(({ end: dateEnd, start: dateStart }) => {
        const turnStart = moment(dateStart);
        const turnEnd = moment(dateEnd);
        return start.isBetween(turnStart, turnEnd, 'minutes', '[)') || end.isBetween(turnStart, turnEnd, 'minutes', '(]');
    });

export const isUnavailableDay = (date, unavailables = []) =>
    unavailables.some(({ all_day, from_date, to_date }) => {
        const fromDate = moment(from_date);
        const toDate = moment(to_date);
        return date.isBetween(fromDate, toDate, 'day', '[]') && !!all_day;
    });
